"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
exports.CSS = {
    container: 'c-SwitchInput',
    label: 'c-SwitchInput__label',
    input: 'c-SwitchInput__input',
    slider: 'c-SwitchInput__slider'
};
var SWITCH_WIDTH = theme_1.DefaultTheme.spacingFactor * 9;
var SWITCH_HEIGHT = theme_1.DefaultTheme.spacingFactor * 3;
var SLIDER_WIDTH = 20;
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex'
    },
    _a[exports.CSS.label] = {
        position: 'relative',
        display: 'inline-block',
        width: "".concat(SWITCH_WIDTH, "px"),
        height: "".concat(SWITCH_HEIGHT, "px"),
        margin: '5px'
    },
    _a[exports.CSS.input] = (_b = {
            opacity: 0
        },
        _b["&:checked + .".concat(exports.CSS.slider)] = {
            'background-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteBlue.C700, 0.5)
        },
        _b["&:checked + .".concat(exports.CSS.slider, ":before")] = {
            transform: "translateX(".concat(SWITCH_WIDTH - SLIDER_WIDTH, "px)"),
            'background-color': theme_1.DefaultTheme.color.primary
        },
        _b["&:focus + .".concat(exports.CSS.slider)] = {
            outline: "1px solid ".concat(theme_1.DefaultTheme.color.primary)
        },
        _b),
    _a[exports.CSS.slider] = {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        'background-color': theme_1.DefaultTheme.font.color.disabled,
        transition: '.4s',
        'border-radius': "".concat(SWITCH_WIDTH, "px"),
        '&:before': {
            position: 'absolute',
            content: '""',
            height: "".concat(SLIDER_WIDTH, "px"),
            width: "".concat(SLIDER_WIDTH, "px"),
            top: "-4px",
            left: 0,
            'background-color': theme_1.DefaultTheme.font.color.white,
            transition: '.4s',
            'border-radius': '50%',
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2
        }
    },
    _a);
//# sourceMappingURL=switch.input.style.js.map